import React from 'react';
import {
  FormControl,
} from 'react-bootstrap';

const NativeDropdown = ({
  className,
  disabled,
  placeholder = 'Make a selection',
  onBlur,
  onChange,
  options,
  value,
}) => (
  <FormControl
    className={className}
    componentClass="select"
    disabled={disabled}
    onBlur={onBlur}
    onChange={(event) => {
      let selectedOption = options.filter(option => option.value === event.target.value)[0];
      onChange(selectedOption.value);
    }}
    style={{paddingLeft: '1em'}}
    value={value || placeholder}
  >
    {
      !value &&
      <option disabled hidden>{placeholder}</option>
    }
    {
      options.map(option => (
        <option
          key={option.value}
          value={option.value}
        >
          {option.label}
        </option>
      ))
    }
  </FormControl>
);

export default NativeDropdown;